module.exports = __webpack_public_path__ + "static/img/t2.47e695d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/pic/t2.jpg
// module id = YQUy
// module chunks = 11